import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Window } from "../../components/DraggableWindow/types";

interface WindowState {
    windows: Window[];
    highestZIndex: number;
}

const initialState: WindowState = {
    windows: [],
    highestZIndex: 100,
};

const windowSlice = createSlice({
    name: "window",
    initialState,
    reducers: {
        closeWindow: (state, action: PayloadAction<string>) => {
            state.windows = state.windows.filter((window) => window.id !== action.payload);
        },
        minimizeWindow: (state, action: PayloadAction<string>) => {
            state.windows = state.windows.map((window) => (window.id === action.payload ? { ...window, isMinimized: true } : window));
        },
        bringToFront: (state, action: PayloadAction<string>) => {
            state.highestZIndex += 1;
            state.windows = state.windows.map((window) =>
                window.id === action.payload ? { ...window, zIndex: state.highestZIndex } : window
            );
        },
        openWindow: (state, action: PayloadAction<{ id: string; title: string; component: React.ReactNode }>) => {
            state.highestZIndex += 1;
            const newWindow: Window = {
                id: action.payload.id,
                title: action.payload.title,
                component: action.payload.component,
                isMinimized: false,
                position: { x: 100 + state.windows.length * 30, y: 50 + state.windows.length * 30 },
                size: { width: 800, height: 600 },
                zIndex: state.highestZIndex,
            };
            state.windows.push(newWindow);
        },
    },
});

export const { closeWindow, minimizeWindow, bringToFront, openWindow } = windowSlice.actions;
export default windowSlice.reducer;
